import { RouteMapping } from './route-mapping.js';
const operationalMetricsRoutes = {
    UsageStatsPage: {
        path: '/',
        pageName: 'UsageStatsPage',
        component: 'UsageStatsScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    OperationalMetricsPage: {
        path: '/operational-metrics',
        pageName: 'OperationalMetricsPage',
        component: 'OperationalMetricsScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    AuthCallbackPage: {
        path: '/auth-callback',
        pageName: 'AuthCallbackPage',
        component: 'AuthCallbackScreen',
        protectedRoute: false,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    }
};
export class OperationalMetricsRouteMapping extends RouteMapping {
    constructor() {
        super(operationalMetricsRoutes);
    }
}
//# sourceMappingURL=operational-metrics.js.map